module.exports = __webpack_public_path__ + "img/en_cancel.6d7e13a5.png";